import PropTypes from 'prop-types'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { NumericFormat } from 'react-number-format'

import { toastErrorLog } from '../../helpers/toastErrorLog'
import * as presupuestosItemService from '../servicios/presupuestosItemService'

const PresupuestoFormItem = ({ idPresupuesto, onUpdate }) => {
  const [formData, setFormData] = useState({
    idPresupuesto,
    descripcion: '',
    cantidad: 0,
    moneda: 0,
    uMedida: 0,
    precio: 0,
    total: 0
  })
  const [clicked, setClicked] = useState(false)
  const [error, setError] = useState('')

  const onChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    setError('')
  }

  const calcularTotal = () => {
    setFormData((prev) => ({
      ...prev,
      total: prev.cantidad !== 0 && prev.precio !== 0 ? prev.cantidad * prev.precio : 0
    }))
  }

  const validarCampos = () => {
    if (!formData.descripcion.trim()) {
      return 'La descripción no puede estar vacía'
    }
    if (parseFloat(formData.precio) <= 0) {
      return 'El precio debe ser mayor que 0'
    }
    if (parseFloat(formData.cantidad) <= 0) {
      return 'La cantidad debe ser mayor que 0'
    }
    return ''
  }

  const onSubmit = async (e) => {
    try {
      e.preventDefault()
      setClicked(true)
      const errorMsg = validarCampos()
      if (errorMsg) {
        setError(errorMsg)
        setClicked(false)
        return
      }

      const item = {
        idPresupuesto: formData.idPresupuesto,
        descripcion: formData.descripcion,
        cantidad: parseFloat(formData.cantidad),
        moneda: parseInt(formData.moneda),
        uMedida: parseInt(formData.uMedida),
        precio: parseFloat(formData.precio),
        total: parseFloat(formData.total)
      }

      const { data } = await presupuestosItemService.insertar(item)
      onUpdate(data)
      setClicked(false)
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar el presupuesto.`
      toastErrorLog(error, mensaje, 'presupuestos')
    } finally {
      setClicked(false)
    }
  }

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col">
            Descripción Item:
            <input
              name="descripcion"
              type="text"
              className="input-text ml-2"
              onChange={onChange}
              required
            />
          </div>
          <div className="col">
            Cantidad:
            <NumericFormat
              name="cantidad"
              required
              onChange={onChange}
              onBlur={calcularTotal}
              className="input-text ml-2"
              thousandSeparator={false}
              decimalScale={2}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            Moneda:
            <select
              name="moneda"
              id=""
              className="select-publicacion-chico ml-2"
              onChange={onChange}
              required
            >
              <option value="">Seleccionar</option>
              <option value="1">Pesos</option>
              <option value="2">Dolar</option>
              <option value="3">Euro</option>
            </select>
          </div>
          <div className="col">
            Precio:
            <NumericFormat
              name="precio"
              required
              onChange={onChange}
              onBlur={calcularTotal}
              className="input-text ml-2"
              thousandSeparator={false}
              decimalScale={2}
              placeholder="$0.00"
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            Unidad Medida:
            <select
              name="uMedida"
              id=""
              className="select-publicacion-chico ml-2"
              onChange={onChange}
              required
            >
              <option value="">Seleccionar</option>
              <option value="1">Unidad</option>
              <option value="2">Metros</option>
              <option value="3">Kilo</option>
            </select>
          </div>
          <div className="col">
            Total:
            <NumericFormat
              value={formData.total}
              displayType={'text'}
              thousandSeparator={true}
              decimalSeparator={'.'}
              fixedDecimalScale={true}
              decimalScale={2}
              prefix={'$'}
              className="ml-2"
            />
          </div>
        </div>
        {error && (
          <div className="row mb-2">
            <div className="col text-danger fw-bold text-center">{error}</div>
          </div>
        )}
        <div className="row">
          <div className="col-4"></div>
          <div className="col-4">
            <button type="submit" className="btn btn-volver-comprar" disabled={clicked}>
              {clicked ? (
                <Spinner animation="border" role="status"></Spinner>
              ) : (
                'Agregar Item'
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

PresupuestoFormItem.propTypes = {
  idPresupuesto: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired
}

export default PresupuestoFormItem

PresupuestoFormItem.propTypes = {
  idPresupuesto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onUpdate: PropTypes.func.isRequired
}
